import styles from '@/components/Shares/Button.module.css';
import { Icons } from '@/components/Shares/Icons';
import { MODAL, useModalAction } from '@/providers/ModalActionProvider';
import { ActionIcon } from '@mantine/core';
export const SearchButton = () => {
  const {
    openModal,
    setOpenModal
  } = useModalAction();
  return <ActionIcon size="input-md" classNames={{
    root: styles.btnIcon
  }} mod={{
    active: openModal === MODAL.SEARCH
  }} onClick={() => setOpenModal(MODAL.SEARCH)}>
      <Icons className="icon-pr-line-search" fontSize={24} />
    </ActionIcon>;
};